import {Component} from '@angular/core';
import {HeaderComponent} from '@app/header/header.component';
import {GoBackDirective} from '@util/directives/go-back.directive';
import {MarkantElementsModule} from '@markant/elements-angular';
import {ToolbarComponent} from '@app/toolbar/toolbar.component';

@Component({
  selector: 'app-impressum',
  templateUrl: './impressum.component.html',
  styleUrls: ['./impressum.component.scss'],
  standalone: true,
  imports: [HeaderComponent, GoBackDirective, MarkantElementsModule, ToolbarComponent],
})
export class ImpressumComponent {}
